/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class ProcedureRequest extends MainRequest {

    static addProcedure(data) {
        return this.postSEC(ServicePath.PROCEDURE_ADD, data);
    }

    static listAllProcedures() {
        return this.getSEC(ServicePath.PROCEDURE_LIST_ALL);
    }

    static listAllProceduresByType(data) {
        return this.postSEC(ServicePath.PROCEDURE_LIST_ALL_BY_TYPE, data);
    }

    static updateProcedure(data) {
        return this.postSEC(ServicePath.PROCEDURE_UPDATE, data)
    }

    static listAttentionTypes(){
        return this.getSEC(ServicePath.ATTENTION_TYPE_LIST);
    }

}